import { render, staticRenderFns } from "./ti5.vue?vue&type=template&id=74927625&scoped=true&"
import script from "./ti5.vue?vue&type=script&lang=js&"
export * from "./ti5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74927625",
  null
  
)

export default component.exports